import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BrandStory from "../pages/brand-story/page";
import Products from "../pages/products/page";
import News from "../pages/news/page";
import CraftDiary from "../pages/craft-diary/page";
import GiftBox from "../pages/gift-box/page";
import Franchise from "../pages/franchise/page";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/brand-story",
    element: <BrandStory />,
  },
  {
    path: "/products",
    element: <Products />,
  },
  {
    path: "/news",
    element: <News />,
  },
  {
    path: "/craft-diary",
    element: <CraftDiary />,
  },
  {
    path: "/gift-box",
    element: <GiftBox />,
  },
  {
    path: "/franchise",
    element: <Franchise />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;